import React, { useState } from 'react';
import { createBrowserRouter, RouterProvider, Outlet } from 'react-router-dom';
import { isAuthenticated, clearTokens } from './auth';
import Layout from './components/Layout';
import Login from './pages/Login';
import Home from './pages/Home';
import BuyOnClose from './pages/BuyOnClose';
import StraightPurchase from './pages/StraightPurchase';
import PriceBasedRunningMan from './pages/PriceBasedRunningMan';
import TrailingSell from './pages/TrailingSell';
import Analytics from './pages/Analytics';
import Simulation from './pages/Simulation';

// Handles auth state and wraps routes in the Layout.
// Must live inside the router so useBlocker works in child pages.
function AuthenticatedApp() {
  const [authed, setAuthed] = useState(isAuthenticated);

  if (!authed) {
    return <Login onLogin={() => setAuthed(true)} />;
  }

  const handleLogout = () => {
    clearTokens();
    setAuthed(false);
  };

  return (
    <Layout onLogout={handleLogout}>
      <Outlet />
    </Layout>
  );
}

const router = createBrowserRouter([
  {
    path: '/',
    element: <AuthenticatedApp />,
    children: [
      { index: true,                        element: <Home /> },
      { path: 'buy-on-close',               element: <BuyOnClose /> },
      { path: 'straight-purchase',          element: <StraightPurchase /> },
      { path: 'price-based-running-man',    element: <PriceBasedRunningMan /> },
      { path: 'trailing-sell',              element: <TrailingSell /> },
      { path: 'analytics',                  element: <Analytics /> },
      { path: 'simulation',                 element: <Simulation /> },
    ],
  },
]);

export default function App() {
  return <RouterProvider router={router} />;
}
